// "You're on a free trial / sign up" messages, played after every few songs
// for signed-in accounts that haven't subscribed (trial running or ended). The audio ships with the player (public/audio/freetrial).

export const SONGS_BETWEEN_FREE_TRIAL_MESSAGES = 2

export const FREE_TRIAL_MESSAGES = [
  // titles as the files are titled (shown as "Free Trial - <title>")
  { file: 'get-the-edge.mp3', title: 'Get the edge, turn up your workout with GymRadio.com' },
  { file: 'get-your-free-trial.mp3', title: 'Get your free trial at GymRadio.com 01' },
  { file: 'get-your-free-trial-2.mp3', title: 'Get your free trial at GymRadio.com 02' },
  { file: 'listening-to-free-trial.mp3', title: 'You’re listening to a free trial of GymRadio.com' },
  { file: 'sign-up-for-free-trial.mp3', title: 'Sign up for your Free Trial at GymRadio.com 01' },
  { file: 'sign-up-for-free-trial-2.mp3', title: 'Sign up for your Free Trial at GymRadio.com 02' },
  { file: 'sign-up.mp3', title: 'Sign up at GymRadio.com' }
]

const MUSIC_TYPES = ['song', 'topsong']

// Adds a 'freetrial' slot after every N music tracks in a playlist schema.
export function withFreeTrialMessages (schema, every = SONGS_BETWEEN_FREE_TRIAL_MESSAGES) {
  // The playlist loops over this schema, so repeat it until its song count
  // divides evenly; then the gap stays the same when it wraps around.
  const musicCount = schema.filter((type) => MUSIC_TYPES.indexOf(type) >= 0).length
  if (musicCount === 0) return schema
  let full = schema
  while (full.filter((type) => MUSIC_TYPES.indexOf(type) >= 0).length % every !== 0) {
    full = full.concat(schema)
  }
  schema = full

  const out = []
  let songs = 0
  schema.forEach((type) => {
    out.push(type)
    if (MUSIC_TYPES.indexOf(type) >= 0) {
      songs++
      if (songs >= every) {
        out.push('freetrial')
        songs = 0
      }
    }
  })
  return out
}

// Hands out the messages in a shuffled order so the same one doesn't repeat back to back.
export class FreeTrialMessages {
  queue = []
  last = ''

  next () {
    if (this.queue.length === 0) {
      this.queue = FREE_TRIAL_MESSAGES
        .map((m) => [Math.random(), m])
        .sort((a, b) => a[0] - b[0])
        .map((pair) => pair[1])
      if (this.queue.length > 1 && this.queue[0].file === this.last) {
        this.queue.push(this.queue.shift())
      }
    }
    const m = this.queue.shift()
    this.last = m.file
    return {
      uuid: `freetrial-${m.file.replace('.mp3', '')}`,
      type: 'promotion',
      viewType: 'promotion',
      artist: 'Free Trial',
      title: m.title,
      url: `${process.env.PUBLIC_URL || ''}/audio/freetrial/${m.file}`,
      gaiaId: ''
    }
  }
}
